<router-outlet></router-outlet>

<!-- Dialogs -->
<app-no-network-dialog></app-no-network-dialog>
<app-no-server-dialog></app-no-server-dialog>
<app-browser-not-compatible-dialog></app-browser-not-compatible-dialog>